/**
 * An object containing events for about modal events
 */
export class AboutModalEvent {
    /**
     * Flag indicating Modal is open
     */
    close?: boolean;
}
